export default "__VITE_ASSET__b66cf18b__"